import { useContext, useState, useEffect, useRef, useCallback } from 'react';

// 导入样式文件
import './Header.less';
// 导入Logo图片

// 导入Icon组件
import Icon from '@/components/iconfont/Icon';
// 导入编辑上下文
import { EditContext } from '@/context/EditContext';
import { projectController } from '@/api';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import message from '@/utils/message';
import { useDrawer } from '@/hooks/DrawerHooks.js';
import export_success from '@/assets/edit/export_success.png';
import view from '@/assets/edit/view.png';
import download from '@/assets/edit/download.png';
import member2 from '@/assets/layouts/dashboard/member.png';
// import EditPopUp from '../popup/Popup';
import { useTranslation } from 'react-i18next';
import { EseClosePopup } from '@/hooks/useClosePopup';
// Header组件 - 页面顶部导航栏
export default function Header() {
  // 从上下文中获取项目名称
  const { t } = useTranslation();

  const {
    projectDetail,
    // setProjectDetail,
    // setExportPopUpFlag,
    // canUndo,
    // canRedo,
    // sessionId,
    // setCanUndo,
    // setCanRedo,
    // setUnRedoUpdate,
    // spaceBarBlocked,
    projectTotalTime,
    // userInfo,
    userSubscription,
    // setSentenceList,
    // setSubtitleBox,
    setExportPop,
  } = useContext(EditContext);

  const { setIsOpen } = useDrawer();
  const [waitPreDownload, setWaitPreDownload] = useState(false);
  // function preDownload() {
  //   setWaitPreDownload(true);
  //   return shareController
  //     .preDownloadVideo(projectDetail.id)
  //     .then((res) => {
  //       if (res?.code !== 0) {
  //         setWaitPreDownload(false);
  //       } else if (res?.data.url) {
  //         setWaitPreDownload(false);
  //         return true;
  //       }
  //     })
  //     .catch((e) => {
  //       setWaitPreDownload(false);
  //       const error = JSON.parse(e);
  //       if (error?.code === -104) {
  //         setIsOpen(true);
  //       }
  //     });
  // }
  // const handleShare = async () => {
  //   window.onClickGATrackEvent('edit-share');
  //   const link = `${window.location.origin}/share?code=${projectDetail.shareCode}`;
  //   await navigator.clipboard.writeText(link);
  //   const hasUrl = await preDownload();
  //   if (hasUrl) {
  //     message.success('Link copied !', {
  //       duration: 2000,
  //     });
  //   }
  // };
  useWebSocket(MessageEventType.PRE_DOWNLOAD_COMPLETE, ({ projectId, downloadUrl, isSuccess }) => {
    if (projectId === projectDetail.id && isSuccess && downloadUrl) {
      if (waitPreDownload) {
        setWaitPreDownload(false);
        message.success(t('As_Edit_CopyLink'), {
          duration: 2000,
        });
      }
    }
  });
  const isFreeUser = userSubscription?.level === 1;
  const handleExportShow = () => {
    // SentryTracker.captureEvent('editpage_export_top_click', userInfo?.email);
    window.onClickGATrackEvent('edit-export');
    if (isFreeUser) {
      setIsOpen(true);
      return;
    }
    if (projectDetail.state !== 2 && projectDetail.state !== 4 && projectDetail.state !== 3) {
      message.info('Please try exporting after the video is successfully transcribed');
      return;
    }
    if (projectTotalTime <= 0) {
      message.info('Exporting requires at least one sentence');
      return;
    }

    // setExportPopUpFlag(true);
    setExportPop(true);
  };

  return (
    // 头部容器
    <div className="header_box">
      {/* 左侧区域 - Logo和项目名称 */}
      <div className="header_left">
        <div className="project_name">
          {/* {projectDetail?.name?.length > 200
            ? projectDetail?.name?.substring(0, 200) + '...'
            : projectDetail?.name} */}
          {projectDetail?.name}
        </div>
      </div>
      {/* 右侧区域 - 功能按钮 */}
      <div className="header_right">
        {/* 撤销按钮 */}
        {/* <div className={`undo_box ${canUndo ? 'undo_active' : ''}`} onClick={handleUndo}>
          <Icon name="icon-undo" className="undo_icon" />
        </div> */}
        {/* 重做按钮 */}
        {/* <div className={`undo_box ml-[10px] ${canRedo ? 'redo_active' : ''}`} onClick={handleRedo}>
          <Icon name="icon-undo-1" className="redo_icon" />
        </div> */}
        {/* 分享按钮 */}
        {/* <button
          className="btn btn-primary btn-outline"
          onClick={handleShare}
          disabled={waitPreDownload}>
          {t('As_Recording_Share')}
          {waitPreDownload ? (
            <span className="loading loading-spinner loading-sm"></span>
          ) : (
            <Icon name="icon-share" className="upload_icon" style={{ fontSize: '20px' }}></Icon>
          )}
        </button> */}
        {/* 导出按钮 */}
        <button className="btn btn-primary export_btn" onClick={handleExportShow}>
          <Icon name="icon-export" className="upload_icon" />
          {t('As_Edit_Export')}
        </button>
      </div>
      <ExportPopUp />
    </div>
  );
}

function ExportPopUp() {
  const { t } = useTranslation();
  const {
    ExportPop,
    setExportPop,
    projectDetail,
    setProjectDetail,
    sessionId,
    captionsItem,
    sentenceList,
    userDetail,
    setExportPayPop,
  } = useContext(EditContext);
  const PopUpRef = useRef();
  const exportThrottle = useRef(false);
  const resolution = [
    // { id: 0, value: '480p' },
    { id: 1, value: '720p', vip: false },
    { id: 2, value: '1080p', vip: true },
    // { id: 3, value: '1440p' },
    // { id: 4, value: '2160p' },
  ];
  const fileType = [
    { name: 'SRT', value: 0 },
    { name: 'TXT', value: 1 },
    { name: 'ASS', value: 2 },
  ];
  const [exportLevel, setExportLevel] = useState(0);
  const [progress, setProgress] = useState(0);
  // 分辨率
  const [resolutionValue, setResolutionValue] = useState(1);
  const [fileValue, setFileValue] = useState(-1);
  const [needUpgrade, setNeedUpgrade] = useState(false);
  useEffect(() => {
    if (ExportPop) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current.close();
      setExportLevel(0);
    }
  }, [ExportPop, exportLevel]);
  useEffect(() => {
    setProgress(projectDetail.progress);
    if ([3].includes(projectDetail.state)) {
      setExportLevel(projectDetail.state - 2);
      setExportPop(true);
    }
  }, [projectDetail]);
  const closePop = () => {
    setExportPop(false);
  };
  const nextLevel = async () => {
    window.onClickGATrackEvent('edit-export-confirm');
    if (exportThrottle.current) return;
    exportThrottle.current = true;
    try {
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      if (fileValue !== -1) {
        const res = await projectController.exportSubtitle({
          projectId: projectItem.id,
          body: {
            sessionId,
            type: fileValue,
          },
        });
        if (res.code === 0) {
          location.href = res.data;
        }
      }
      if (resolutionValue !== -1) {
        await projectController.exportProject({
          projectId: projectItem.id,
          body: {
            sessionId,
            lipSync: false,
            resolution: Number(resolutionValue),
          },
        });
        setExportLevel(1);
      }
    } catch (error) {
      console.log(error);
      message.error('Export failed');
    } finally {
      exportThrottle.current = false;
    }
  };
  // 导出中
  useWebSocket(
    MessageEventType.EXPORT_PROCESS,
    useCallback(({ process, projectId }) => {
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      if (projectItem.id === projectId) {
        console.log('导出中');
        console.log(projectId);
        setProgress(process);
      }
    }, []),
  );
  // 导出成功
  useWebSocket(
    MessageEventType.EXPORT_SUCCESS,
    useCallback(
      ({ url, projectId }) => {
        console.log(captionsItem, '导出成功');
        const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
        if (projectItem.id === projectId) {
          setProgress(100);
          window.onClickGATrackEvent('export-success');
          setExportLevel(2);
          setExportPop(true);

          setProjectDetail({
            ...projectDetail,
            state: 4,
            videoUrl: url,
            subtitleStyleId: captionsItem.id,
            sentence: sentenceList,
          });
        }
      },
      [projectDetail, captionsItem],
    ),
  );
  const handleDownLoad = async () => {
    window.onClickGATrackEvent('edit-export-download');
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = await projectController.download({
        projectId: projectItem.id,
      });
      if (res.code === 0) {
        location.href = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleShare = async () => {
    window.onClickGATrackEvent('edit-export-viewlink');
    const link = `${window.location.origin}/share?code=${projectDetail.shareCode}`;
    await navigator.clipboard.writeText(link);
    message.success(t('As_Edit_CopyLink'), {
      duration: 2000,
    });
  };
  const showUpgradePop = () => {
    setExportPayPop(true);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      {exportLevel != 1 && <EseClosePopup close={closePop} />}
      <div className="modal-box export-box max-w-5xl">
        <div className="title export-title">
          <div className="exportPopTitle">{t('As_Edit_Export')}</div>
          {exportLevel != 1 && (
            <span className="export-close" onClick={closePop}>
              <Icon name="icon-close-stroke" style={{ fontSize: '20px' }} />
            </span>
          )}
        </div>
        {exportLevel == 0 ? (
          <>
            <div className="export-tip">{t('As_Edit_ExportTitleDesc334')}</div>
            <div className="chooseBlock">
              <div className="chooseBlock_left">
                {resolutionValue === -1 ? (
                  <input
                    type="checkbox"
                    style={{ opacity: 0.3 }}
                    checked
                    onChange={() => {
                      setResolutionValue(1);
                      setNeedUpgrade(false);
                    }}
                    className="checkbox checkbox-primary cursorPointer"
                  />
                ) : (
                  <input
                    type="checkbox"
                    checked
                    onChange={() => {
                      setResolutionValue(-1);
                      setNeedUpgrade(false);
                    }}
                    className="checkbox checkbox-primary cursorPointer"
                  />
                )}
                {t('As_Edit_ExportVideo334')}
              </div>
              <div className="chooseBlock_right">
                {resolution.map((res, index) => (
                  <div
                    key={index}
                    onClick={() =>
                      setResolutionValue((val) => {
                        const info = val === res.id ? -1 : res.id;
                        if (info !== -1 && res.vip) {
                          setNeedUpgrade(userDetail.subscription.id === 1);
                        } else {
                          setNeedUpgrade(false);
                        }
                        return info;
                      })
                    }
                    className={`resolutionBlock ${resolutionValue === res.id && 'checkBlock'} cursorPointer`}>
                    {res.value}
                    {res.vip && <img src={member2} />}
                  </div>
                ))}
              </div>
            </div>
            <div className="chooseBlock">
              <div className="chooseBlock_left">
                {fileValue === -1 ? (
                  <input
                    type="checkbox"
                    checked
                    style={{ opacity: 0.3 }}
                    onChange={() => {
                      setFileValue(0);
                    }}
                    className="checkbox checkbox-primary"
                  />
                ) : (
                  <input
                    type="checkbox"
                    checked
                    onChange={() => {
                      setFileValue(-1);
                    }}
                    className="checkbox checkbox-primary"
                  />
                )}
                {t('As_Edit_ExportSubtitles334')}
              </div>
              <div className="chooseBlock_right">
                {fileType.map((res, index) => (
                  <div
                    key={index}
                    onClick={() => setFileValue((val) => (val === res.value ? -1 : res.value))}
                    className={`resolutionBlock fileBlock ${fileValue === res.value && 'checkBlock'} cursorPointer`}>
                    {res.name}
                  </div>
                ))}
              </div>
            </div>
            <div className="next">
              <button
                className="btn btn-primary btn-xs next-btn cursorPointer"
                disabled={fileValue === -1 && resolutionValue === -1}
                onClick={needUpgrade ? showUpgradePop : nextLevel}>
                {needUpgrade ? t('As_Edit_ExportUpgrade334') : t('As_Edit_Export')}
              </button>
            </div>
          </>
        ) : exportLevel == 1 ? (
          <>
            <div className="exportlevel2">
              <div
                className="radial-progress"
                style={{ '--value': progress, '--size': '128px', '--thickness': '10px' }}
                role="progressbar">
                {progress}%
              </div>
              <div className="title">{t('As_Edit_ExpProcessing')}</div>
              <div className="tip">{t('As_Edit_ExpFollowUp')}</div>
            </div>
          </>
        ) : (
          <>
            <div className="exportlevel3">
              <div className="tip">{t('As_Edit_AlterDownloadVid')}</div>
              <img src={export_success} />
              <div className="btn-list">
                <button className="btn btn-xs" onClick={handleShare}>
                  <img src={view} />
                  {t('As_Edit_Link')}
                </button>
                <button className="btn btn-primary btn-xs" onClick={handleDownLoad}>
                  <img src={download} />
                  {t('As_Edit_Download')}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </dialog>
  );
}
